export default __webpack_public_path__ + "static/media/robotron.d031cb27.jpg";